import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState, forwardRef, cloneElement, memo } from 'react';
import { usePopper } from 'react-popper';
import Modal from '../Modal';
import { flipPlacement, getAnchorEl } from './utils';
import { setRef } from '../utils/withForwardedRef';
var Popper = forwardRef(function (_a, ref) {
  var anchorEl = _a.anchorEl,
      _b = _a.placement,
      placement = _b === void 0 ? 'bottom' : _b,
      children = _a.children,
      modifiers = _a.modifiers,
      strategy = _a.strategy,
      onFirstUpdate = _a.onFirstUpdate,
      modalProps = __rest(_a, ["anchorEl", "placement", "children", "modifiers", "strategy", "onFirstUpdate"]);

  var _c = useState(null),
      tooltipElement = _c[0],
      setTooltipElement = _c[1];

  var _d = usePopper(getAnchorEl(anchorEl), tooltipElement, {
    placement: flipPlacement(placement),
    modifiers: modifiers,
    strategy: strategy,
    onFirstUpdate: onFirstUpdate
  }),
      styles = _d.styles,
      attributes = _d.attributes;

  var handleRef = useCallback(function (node) {
    if (children.ref) {
      setRef(children.ref, node);
    }

    setTooltipElement(node);
  }, [children.ref]);
  return _jsx(Modal, __assign({
    ref: ref,
    hideBackdrop: true,
    BackdropProps: {
      invisible: true
    },
    absolute: true
  }, modalProps, {
    children: cloneElement(children, __assign(__assign(__assign(__assign({}, children.props), {
      style: styles.popper
    }), attributes.popper), {
      ref: handleRef
    }))
  }));
});
export default memo(Popper);